import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function DailyRevealSection() {
  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="px-4 md:px-6">
        {/* 区块标题 */}
        <div className="flex flex-col lg:flex-row items-start lg:items-end justify-between mb-10 gap-4">
          <div>
            <span className="text-xs font-semibold tracking-widest uppercase text-secondary-500">DAILY REVEAL</span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-1">
              每日首发爆料
            </h2>
            <p className="text-sm text-foreground-600 mt-2 max-w-lg">
              网红塌房反差视频、博主爆料聊天记录，黑料大瓜实时追踪不停更
            </p>
          </div>
          <Link
            to="/category/meiri-baoliao"
            className="whitespace-nowrap text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer flex items-center gap-1"
          >
            查看全部 <i className="ri-arrow-right-line" />
          </Link>
        </div>

        {/* 分类卡片 */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative bg-background-50 rounded-2xl p-6 md:p-8 hover:bg-background-50 transition-all duration-300 cursor-pointer border border-background-200/70 hover:border-primary-200"
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-500 transition-colors duration-300">
                  <i className={`${cat.icon} text-xl text-primary-500 group-hover:text-background-50 transition-colors duration-300`} />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-lg font-semibold text-foreground-950 mb-1 whitespace-nowrap">
                    {cat.name}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {cat.description}
                  </p>
                </div>
                <div className="flex items-center">
                  <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-primary-500 transition-colors duration-300" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}